import lottie from 'lottie-web'
import { config } from '../core/'

class Lottie {
  get OPTIONS() {
    return {
      renderer: 'svg', 
      loop: false, 
      autoplay: false,
    };
  }

  constructor() {
    this.animations = {}
  }

  createLottie(array) {
    for (const item of array) {
      const lottieId = item.dataset.animateId
      const lottieLoop = item.dataset.animateLoop
      this.animations[lottieId] = {
        lottie: lottie.loadAnimation({
          container: item,
          renderer: 'svg',
          loop: lottieLoop ? true : false,
          autoplay: false,
          path: `${config.path.json}${lottieId}.json`
        }),
      }
    }
  }
}

export default Lottie;
